import { progressBarSchema } from "@redotech/redo-model/checkouts/checkout-optimization-settings";
import * as z from "zod/v4";

export const getStorefrontProgressBarSettings = {
  name: "getStorefrontProgressBarSettings" as const,
  input: z.null(),
  output: z.object({ settings: progressBarSchema.optional() }),
};
